import React from "react"
import { PageProps } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout/layout"
import About from "../components/about/about"
import PageTitle from "../components/pageTitle/pageTitle"
import BlockContainer from "../components/blockContainer/blockContainer"
import styled from "styled-components"
import SameRatioContainer from "../components/sameRatioContainer/sameRatioContainer"
import Image from "../components/gatsbyImage/gatsbyImage"
import { profile } from "../providers/profile/profile.data"
import LinkContainer from "../components/linkContainer/linkContainer"
import { device } from "../components/mediaQuery/mediaQuery"

const AboutPage: React.FC<PageProps> = () => {
  const containerRatio = 9 / 16

  return (
    <>
      <Layout>
        <SEO title="About" />
        <PageTitle>About</PageTitle>
        <About />
        <ProjectContainer title={`Projects`}>
          <Wrap>
            {profile.project.map(({ id, name, image, link }) => (
              <Project key={id} to={link} target="_blank">
                <StyledSameRatioContainer ratio={containerRatio} width={`100%`}>
                  <Image filename={image.filename} alt={image.alt} />
                </StyledSameRatioContainer>
                <ProjectTitle>{name}</ProjectTitle>
              </Project>
            ))}
          </Wrap>
        </ProjectContainer>
      </Layout>
    </>
  )
}

const ProjectContainer = styled(BlockContainer)`
  background-color: #d03f00;
`
const Wrap = styled.div`
  @media ${device.tablet} {
  }
  @media ${device.desktop} {
    display: flex;
  }
`

const Project = styled(LinkContainer)`
  color: white;
  @media ${device.tablet} {
    width: 100%;
  }
  @media ${device.desktop} {
    width: 31.33%;
    :not(:last-child) {
      margin-right: 2%;
    }
  }
`
const ProjectTitle = styled.h4`
  font-weight: bold;
  text-align: center;
  font-size: 24px;
  padding: 10px;
`
const StyledSameRatioContainer = styled(SameRatioContainer)`
  border-radius: 10px;
  overflow: hidden;
`

export default AboutPage
